import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TipsModalComponent } from '../tips/tips-modal/tips-modal.component';
import { RateService } from '../../../../../shared/services/rate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClickhouseService } from '../../../../../shared/services/clickhouse.service';
import { combineLatest } from 'rxjs';
import { MultiChatService } from '../../../../../shared/services/multi-chat.service';

@Component({
  selector: 'app-rate-modal',
  templateUrl: './rate-modal.component.html',
  styleUrls: ['./rate-modal.component.scss'],
})
export class RateModalComponent implements OnInit {
  @Input() expert_id: any;

  @Input() ticket_id: any;

  @Output() rateSkipped = new EventEmitter<any>();

  rateStars = [
    {
      rated: false,
    },
    {
      rated: false,
    },
    {
      rated: false,
    },
    {
      rated: false,
    },
    {
      rated: false,
    },
  ];

  rate = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private rateService: RateService,
    private spinner: NgxSpinnerService,
    private clickHouse: ClickhouseService,
    private chatService: MultiChatService,
  ) {}

  ngOnInit(): void {
    this.rate = 0;
    this.clickHouse.storeEvent('rating_popup_shown').subscribe(() => {});
  }

  setRate(rate: number) {
    this.rate = rate;
    this.rateStars.forEach((star: any) => {
      star.rated = false;
    });
    this.rateStars.forEach((star: any, starIndex) => {
      if (starIndex < rate) {
        star.rated = true;
      }
    });
  }

  sendRate() {
    if (this.rate !== 0) {
      this.spinner.show();
      combineLatest([
        this.rateService.setRate(this.rate, this.expert_id, this.ticket_id),
        this.clickHouse.storeEvent(`rating_${this.rate}_click`),
      ]).subscribe(() => {
        this.spinner.hide();
        if (this.rate > 3) {
          this.modalService.open(TipsModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        } else {
          import('../feedback/feedback-modal/feedback-modal-component.module').then(
            ({ FeedbackModalComponentModule }) => {
              this.modalService.open(FeedbackModalComponentModule.getComponent(), {
                backdrop: 'static',
                keyboard: false,
                centered: true,
              });
            },
          );
        }
        this.rateSkipped.emit();
        this.activeModal.close();
      });
    }
  }

  closeModal() {
    this.activeModal.close('Cross click');
    combineLatest([
      this.clickHouse.storeEvent('rating_close_click'),
      this.chatService.closeTicket(this.ticket_id),
    ]).subscribe(([]) => {
      this.rateSkipped.emit();
      this.modalService.open(TipsModalComponent, {
        backdrop: 'static',
        keyboard: false,
      });
    });
  }

  trackByFn(_index: any, item: any) {
    return item.id;
  }
}
